import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { sendDwh } from 'reactApp/utils/ga';

const sendDwnRadar = (action) => {
    sendDwh({
        eventCategory: 'modal-create-folder-family-docs',
        action,
    });
};

export const renderFamilyDocumentsModal = ({ onClick }) => {
    openPopupHelper({
        popupName: popupNames.FAMILY_DOCUMENTS_MODAL,
        data: {
            onShow: () => {
                sendDwnRadar('show');
            },
            onClick: () => {
                sendDwnRadar('click');
                onClick();
            },
        },
        onClose: () => {
            sendDwnRadar('close');
        },
    });
};
